import React from 'react';
import PropTypes from 'prop-types';

import styles from './styles.scss';

function AvatarGroup({ className, children }) {
  return (
    <ol className={`${styles.list} ${className}`}>
      {React.Children.map(children, (child, index) => (
        <li
          className={styles.listItem}
          style={{ zIndex: children.length - index }}
        >
          {React.cloneElement(child, {
            className: `${child.props.className} ${styles.avatar}`
          })}
        </li>
      ))}
    </ol>
  );
}

AvatarGroup.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

AvatarGroup.defaultProps = {
  className: ''
};

export default AvatarGroup;
